export default {
  // Režimai
  "common.mode.auto": "Savitarpio naudojimas",
  "common.mode.economy": "Ekonomijos režimas",
  "common.mode.exigency": "Avarinis režimas",

  // Įrenginiai
  "common.grid": "Elektros tinklas",
  'common.evChargers': 'Elektromobilių įkrovikliai',
  'common.evCharger': 'Elektromobilių įkroviklis',
  'common.pv': 'Saulės energija',
  'common.inverter': 'Keitiklis',
  'common.pcs': 'Keitiklis + Baterija',
  'common.terminal': 'Prietaisas',
  'common.airc': 'Oro kondicionierius',
  'common.engine': 'Variklis',
  'common.battery': 'Baterija',
  'common.metter': 'Elektros skaitiklis',
  'common.other': 'Kita',
  "common.power": "Galia",
  "common.powerTotal": "Bendra galia",
  "common.voltage": "Įtampa",
  "common.electricity": "Elektros energija",
  "common.current": "Srovė",
  "common.homeUsage": "Bendras namų apkrovimas",
  "common.battery.power": "Baterijos galia",

  // Duomenys
  "common.noDataAvailable": 'Šiuo metu duomenų nėra~',
  'common.tips': 'Patarimas',
  "common.reset": "Atstatyti",
  "common.currencyUnit": '¥',
  "common.submiting": 'Siunčiama, prašome palaukti...',
  "common.close": 'Uždaryti',
  "common.from": 'Iš',
  "common.useIn": 'Naudojama',
  "common.energyPercent": 'Energijos srauto dalis',
  "common.dataFlow": "Duomenų srautas",
  "common.getDataIng": 'Gaunami duomenys, prašome palaukti...',
  "common.pageLoading": 'Puslapis kraunamas, prašome palaukti...',
  "common.reseting": "Puslapio turinys atstatomas, prašome palaukti...",
  "common.save": 'Išsaugoti',
  "common.onlyNumberTips": "Galima įvesti tik skaičius",
  "common.offline": "Neprisijungęs",
  "common.online": "Prisijungęs",
  "common.fault":"Gedimas",
  "common.charge": "Įkrovimas",
  "common.discharge": "Išsikrovimas",
  "common.buy": "Pirkti",
  "common.sell": "Parduoti",
  "common.loadingInfo": 'Kraunama, prašome palaukti...',

  // 
  "common.moreFeatures": "Daugiau funkcijų",
  "common.confirm": 'Patvirtinti',
  "common.saveing": "Išsaugoma, prašome palaukti...",
  "common.searchPlacholder": "Įveskite paieškos raktažodį",
  "common.iSee": 'Supratau',
  "common.pageErrorTips1": "Oi, puslapyje įvyko klaida~",
  "common.pageErrorTips2": "Pabandykite atnaujinti puslapį arba susisiekite su klientų aptarnavimu~",
  "common.refresh": "Atnaujinti",
  "common.backToHome": "Grįžti į pagrindinį puslapį",
  "common.checkTips": "Tikrinama, prašome palaukti...",
  "common.back": "Atgal",
  "common.cancel": "Atšaukti",
  "common.optional": "Neprivaloma",
  "common.required": "Privaloma",
  "common.status": "Būsena",
  "common.statusNoDelete": "Neištrinta",
  "common.statusDelete": "Ištrinta",
  "common.submit": 'Pateikti',
  "common.disable": "Išjungti",
  "common.enable": "Įjungti",
  "common.year": 'metai',
  "common.month": 'mėnuo',
  "common.day": 'diena',
  "common.version": 'Versijos numeris:',
  "common.backHome": ' Grįžti į pagrindinį puslapį',
  "common.backHomeSorry": ' Atsiprašome, puslapis pasiklydo',
  "common.requestTips1": 'Duomenys apdorojami, nepateikite pakartotinai',
  "common.requestTips2": "Sistemos pranešimas",
  "common.requestTips3": "Prisijungimo būsena baigėsi, prisijunkite iš naujo",
  "common.requestTips4": "Prisijungti iš naujo",
  "common.requestTips5": "Negalima sesija arba sesija baigėsi, prisijunkite iš naujo.",
  "common.requestTips6": "Serverio klaida, prašome pabandyti vėliau.",
  "common.requestTips7": "Sistemos užklausos laukimo laikas baigėsi",
  "common.requestTips8": 'Sistemos sąsaja',
  "common.requestTips9": 'Klaida',
  "common.iknow": 'Supratau',
  "common.logoutSuccess": "Atsijungta sėkmingai",
  
  // Sužinokite daugiau komponentas
  "common.knowMore.title": 'Norėdami sužinoti daugiau, susisiekite su BeiNeng',
  "common.knowMore.email": 'El. paštas',
  "common.knowMore.phone": 'Telefonas',
  "common.knowMore.wechat": 'WeChat',
  "common.knowMore.website": 'Oficiali svetainė',
  "common.knowMore.address": 'Adresas',
  "common.knowMore.addressDetail": 'Kambariai 1205 ir 1301, 5 pastatas, Qinghe Rd 8, Huangjingkeng, Huangjiang miestas, Dongguan, Guangdong provincija',
  
  // Vietinis ryšio komponentas
  "common.localConnection": 'Vietinis ryšys',
  "common.operateInApp": 'Prašome atlikti veiksmus programėlėje!',
  
  "common.enbleStaus": "Įjungimo būsena",
  "common.battery.status": "Neįkraunama ir neišsikrauna",

  'account.forgetThePassword': 'Pamiršote slaptažodį',
    'account.logInDirectly': 'Eiti tiesiai į prisijungimą',
    'account.tips1': 'Nukreipiama, prašome palaukti...',
    'account.tips2': 'Pirmiausia perskaitykite ir sutikite su naudojimo sąlygomis!',
    'account.autoLogin': 'Automatinis prisijungimas',
    'account.userLogin': 'Vartotojo prisijungimas',
    'account.registerTips': 'Dar neturite paskyros? Spustelėkite čia norėdami užsiregistruoti',
    'account.userEmail': 'Vartotojo vardas/El. paštas',
    'account.userEmailTips': 'Įveskite vartotojo vardą/el. paštą',
    'account.password': 'Slaptažodis',
    'account.passwordTips': 'Įveskite slaptažodį',
    'account.submit': 'Pateikti',
    'account.submitTips': 'Pateikiama, prašome palaukti...',
    'account.otherLoginTips': 'Arba pasirinkite kitą prisijungimo būdą',
    'account.userRegistration': 'Vartotojo registracija',
    'account.userName': 'Vartotojo vardas',
    'account.userNameTips': 'Įveskite vartotojo vardą',
    'account.emailTips1': 'Įveskite el. pašto adresą',
    'account.emailTips2': 'Neteisingas el. pašto adreso formatas',
    'account.phone': 'Telefono numeris',
    'account.phoneTips1': 'Įveskite telefono numerį',
    'account.phoneTips2': 'Neteisingas telefono numeris',
    'account.phoneTips3': 'Įveskite telefono numerį',
    'account.passwordTips1': 'Įveskite 6-30 simbolių slaptažodį',
    'account.passwordTips2': 'Neteisingas slaptažodžio formatas. Slaptažodis turi būti sudarytas iš raidžių, skaičių, pabraukimo brūkšnių, brūkšnelių ir taškų, 6-12 simbolių ilgio.',
    'account.passwordTips3': 'Slaptažodžiai nesutampa, patikrinkite ir bandykite dar kartą!',
    'account.passwordTips4': 'Įveskite slaptažodį. Slaptažodis turi būti sudarytas iš raidžių, skaičių, pabraukimo brūkšnių, brūkšnelių ir taškų.',
    'account.passwordTips5': 'Patvirtinkite slaptažodį',
    'account.passwordTips6': 'Įveskite patvirtinimo slaptažodį',
    'account.passwordTips7': 'Slaptažodžiai nesutampa, patikrinkite ir bandykite dar kartą!',
    'account.passwordTips8': 'Įveskite patvirtinimo slaptažodį',
    'account.passwordTips9': 'Sveikiname! Registracija sėkminga!',
    'account.passwordTips10': 'Jūsų vartotojo vardas yra:',
    'account.emailIs': 'El. paštas yra:',
    'account.goToLoginPage': 's automatiškai bus nukreipta į prisijungimo puslapį',
    'account.goLogin': 'Prisijungti',
    'account.goRegister': 'Registruotis',
    'account.loginSuccess': 'Prisijungimas sėkmingas',
    'account.email': 'El. paštas',
    'account.sologn': 'Kuriama individualūs energijos sprendimai su rūpesčiu',
    'account.pleaseAgree': 'Aš perskaičiau ir sutinku su',
    'userAgreement.privacyPolicy': 'Privatumo politika',

    "account.code": "Patvirtinimo kodas",
    "account.codeTips": "Įveskite patvirtinimo kodą",
    "account.codeTips2": "Neteisingas patvirtinimo kodas",

    "account.inviteCodeTips": "Įveskite pakvietimo kodą",
    "account.inviteCodeHint": "Norėdami gauti pakvietimo kodą, susisiekite su montuotoju arba priežiūros personalu",
    "account.modifyPasswordByAccount": "Keisti slaptažodį per paskyrą",
    "account.modifyPasswordByEmail": "Keisti slaptažodį el. paštu",
    "account.getPasswordByAccount": "Atkurti slaptažodį per paskyrą",
    "account.getPasswordByEmail": "Atkurti slaptažodį el. paštu",

    "account.sendEmailTips": "Patvirtinimo kodas išsiųstas el. paštu, patikrinkite savo pašto dėžutę",
    "account.name": "Paskyros vardas",
    "account.newPassword": "Naujas slaptažodis",
    "account.confirmNewPassword": "Patvirtinkite naują slaptažodį",
    "account.nameTips": "Įveskite paskyros vardą",
    "account.passwordModifySuccess": "Slaptažodžio keitimas sėkmingas",
    "account.emailCode": "El. pašto patvirtinimo kodas",
    "account.emailCodeTips": "Įveskite el. pašto patvirtinimo kodą",
    "account.emailCodeTips2": "Neteisingas el. pašto patvirtinimo kodas",
    "account.emailModifySuccess": "Slaptažodžio keitimas sėkmingas",
    "account.passworTips1": "Jūsų slaptažodis sėkmingai atkurtas!",
    "account.passwordTips11": "Įveskite patvirtinimo slaptažodį",
    "account.passwordTips12": "Įveskite naują slaptažodį",
    "account.nickname": "Vartotojo slapyvardis",
    "account.modifyNickname": "Keisti vartotojo slapyvardį",
    "account.modifyNicknameSuccess": "Vartotojo slapyvardis sėkmingai pakeistas!",
    "account.nicknameTips": "Įveskite vartotojo slapyvardį",
    'account.nicknameError': 'Vartotojo slapyvardžio keitimas nepavyko!',

    "account.login": 'Prisijungti',
    'account.quickRegister': 'Greita registracija',
    'account.sendCode': 'Siųsti kodą',
    'account.sendTips': 's galima siųsti dar kartą',
    "account.sendEmailIng": 'Siunčiamas el. laiškas, prašome palaukti...',
    'account.emailNotEmpty': 'El. pašto adresas negali būti tuščias',
    'account.registerAccount': 'Registruoti paskyrą',
    'account.registerWelcome': 'Sveiki atvykę į SusprSafe',
    'account.usernameLimit': 'Vartotojo vardas turi prasidėti raide ir gali turėti tik raides, skaičius, pabraukimo brūkšnius, ilgis 5-15 simbolių.',

    'copyright.desc2': 'Svetainės registracijos informacija: Yue ICP-bei 2021169764',

    'editUserInfo.editUserInformation': 'Redaguoti vartotojo informaciją',
    'editUserInfo.modifyUsername': 'Keisti vartotojo vardą',
    'editUserInfo.changePictures': 'Keisti profilio nuotrauką',
    'editUserInfo.savePicturesSuccess': 'Profilio nuotrauka sėkmingai išsaugota',
    'editUserInfo.saveError': 'Išsaugoti nepavyko',
    'editUserInfo.pictureLimit':'Nuotrauka turi būti mažesnė nei 2MB',
    'editUserInfo.uploadPicture':'Įkelti profilio nuotrauką',
    'editUserInfo.picturePreview':'Peržiūrėti',
    
    'editUserInfo.bindPhoneNumber': 'Susieti telefono numerį',
    'editUserInfo.bindEmail': 'Susieti el. paštą',
    'editUserInfo.changePassword': 'Keisti slaptažodį',

    'editUserInfo.notificationSettings': 'Pranešimų nustatymai',
    'editUserInfo.editAccount': 'Redaguoti paskyros informaciją',
    'editUserInfo.waitBingting': 'Vyksta susiejimas, prašome palaukti...',
    'editUserInfo.collapse': 'Sutraukti',
    'editUserInfo.modifyBinding': 'Keisti susiejimą',
    
    'editUserInfo.emailAddress': 'El. pašto adresas',
    'editUserInfo.tips1': 'El. pašto susiejimas sėkmingas',
    'editUserInfo.tips2': 'Išsaugoti nepavyko',
    'editUserInfo.tips3': 'Siunčiamas el. pašto patvirtinimo kodas, prašome palaukti...',
    'editUserInfo.tips4': 'Patvirtinimo kodas išsiųstas el. paštu xxxx, patikrinkite',
    'editUserInfo.tips5': 'Nepavyko išsiųsti patvirtinimo kodo!',
    'editUserInfo.tips6': 'Jau susietas telefono numeris',
    'editUserInfo.tips7': 'Jau susietas el. paštas',
    'editUserInfo.emailTips1': 'Įveskite el. pašto adresą',
    'editUserInfo.emailTips2': 'Neteisingas el. pašto adreso formatas',
    'editUserInfo.emailTips3': 'xxxxs galima siųsti dar kartą',
    'editUserInfo.emailTips4': 'Siųsti kodą',
    'editUserInfo.emailTips5': 'El. pašto patvirtinimo kodas negali būti tuščias',
    'editUserInfo.emailTips6': 'Neteisingas el. pašto patvirtinimo kodas',
    'editUserInfo.emailCode': 'El. pašto patvirtinimo kodas',
    'editUserInfo.save': 'Išsaugoti',

    'editUserInfo.phoneTips1': 'Telefono numerio susiejimas sėkmingas',
    'editUserInfo.phoneTips2': 'Siunčiamas SMS patvirtinimo kodas, prašome palaukti...',
    'editUserInfo.phoneTips3': 'SMS patvirtinimo kodas išsiųstas į telefoną xxxx, patikrinkite',
    'editUserInfo.phoneTips4': 'Nepavyko išsiųsti SMS patvirtinimo kodo!',
    'editUserInfo.phoneTips5': 'Įveskite telefono numerį',
    'editUserInfo.phoneTips6': 'Neteisingas telefono numerio formatas',
    'editUserInfo.phoneTips7': 'Siųsti SMS patvirtinimo kodą',
    'editUserInfo.phoneTips8': 'SMS patvirtinimo kodas',
    'editUserInfo.phoneTips9': 'Telefono patvirtinimo kodas negali būti tuščias',
    'editUserInfo.phoneTips10': 'Neteisingas telefono patvirtinimo kodas',
    'editUserInfo.phone': 'Telefono numeris',


    'editUserInfo.noticeTips1': 'Nepavyko gauti pranešimų nustatymų!',
    'editUserInfo.noticeTips2': 'Pranešimų nustatymai sėkmingai išsaugoti!',
    'editUserInfo.noticeTips3': 'Pranešimas apie žemą baterijos lygį',
    'editUserInfo.noticeTips4': 'Pranešimas apie įkrovimo užbaigimą',
    'editUserInfo.errorNotification': 'Klaidų pranešimas',
    'editUserInfo.updateNotification': 'Atnaujinimo pranešimas',
    'editUserInfo.monthlyStatisticsNotification': 'Mėnesinės statistikos pranešimas',
    'editUserInfo.notificationMethod': 'Gavimo būdas',

    'editUserInfo.userNameTips1': 'Vartotojo vardas sėkmingai išsaugotas',
    'editUserInfo.userNameTips2': 'Nepavyko išsaugoti vartotojo vardo',
    'editUserInfo.userNameTips3': 'Įveskite vartotojo vardą',
    'editUserInfo.userNameTips4': 'Neteisingas vartotojo vardo formatas. Turi būti sudarytas iš skaičių, pabraukimo brūkšnių ir raidžių.',
    'editUserInfo.userNameTips5': 'Įveskite vartotojo vardą',
    'editUserInfo.userNameTips6': 'Išsaugoma, prašome palaukti...',
    'editUserInfo.userName': 'Vartotojo vardas',

    'editUserInfo.avatorTips': 'Spustelėkite norėdami pakeisti profilio nuotrauką',
    'editUserInfo.verifyCodeTips1': 'Įveskite gautą patvirtinimo kodą:',
    'editUserInfo.verifyCodeTips2': 'Dėl jūsų paskyros saugumo, spustelėkite mygtuką norėdami išsiųsti patvirtinimo kodą į originalų telefono numerį:',
    'editUserInfo.verifyCodeTips3': 'Siųsti kodą',
    'editUserInfo.verifyCodeTips4': 'Originalus telefonas patvirtintas, įveskite naują susietinį telefono numerį',
    'editUserInfo.verifyCodeTips5': 'Dėl jūsų paskyros saugumo, spustelėkite mygtuką norėdami išsiųsti patvirtinimo kodą į originalų el. paštą:',
    'editUserInfo.verifyCodeTips6': 'Originalus el. paštas patvirtintas, įveskite naują el. paštą',
    'editUserInfo.verifyCodeTips7': 'Senas slaptažodis',
    'editUserInfo.verifyCodeTips8': 'Pirmiausia susiekite el. paštą!',
    'editUserInfo.verifyCodeTips9': 'Patvirtinimo kodas išsiųstas el. paštu, patikrinkite savo pašto dėžutę',
    "editUserInfo.verifyCodeTips10": ', automatiškai bus nukreipta į prisijungimo puslapį',

    "hems.notice.title": "Pranešimo pavadinimas", 
   "hems.notice.content": "Pranešimo turinys", 
   "hems.notice.operate": "Veiksmas",
   "hems.notice.noRead": "Neperskaitytas",
   "hems.notice.read": "Perskaitytas",
   "hems.notice.warning": "Įspėjimas",
   "hems.notice.error": "Klaida",
   "hems.notice.success": "Statistika ir atsiskaitymas",
   "hems.notice.sys": "Sistemos informacija",
   "hems.notice.operateSuccess": "Veiksmas sėkmingas",
   "hems.notice.operateTips": "Pasirinkite elementus, su kuriais norite atlikti veiksmus",

    // Pagrindinis puslapis
   "hems.home.selfuseRate": "Savitarpio naudojimo lygis",
   "hems.home.percent": "Procentas",
   "hems.home.todayData": "Šiandienos duomenys",
   "hems.home.todayPowerGeneration": "Šiandienos energijos gamyba",
   "hems.home.salesIncome": "Pajamos iš elektros pardavimo",
   "hems.home.saved": "Jums sutaupyta",
   "hems.home.reduce": "Sumažintas anglies pėdsakas",
   "hems.home.tips1": "Nėra duomenų, dar nesate susieję xxxx",
   "hems.home.criticalLoad": "Kritinė apkrova",
   "hems.home.keyVoltage": "Kritinė įtampa",
   "hems.home.householdLoad": "Namų apkrova",
   "hems.home.householdVoltage": "Namų įtampa",
   "hems.home.generalLoad": "Bendroji apkrova",
   "hems.home.generalVoltage": "Bendroji įtampa",
   "hems.home.batteryHealth": "Baterijos sveikata",
   "hems.home.averageTemp": "Vidutinė temperatūra",
   "hems.home.gridLoad": "Tinklo apkrova",
   "hems.home.toggeleDataSource": "Rodytini duomenys pakeisti į:",
   "hems.home.toggleTips": "Ar tikrai norite pakeisti?",
   "hems.home.modeSending": "Režimo komanda siunčiama, prašome palaukti...",
   "hems.home.modeSuccess": "Režimo keitimo komanda sėkmingai išsiųsta!",
   "hems.home.isOnline": "Ar prisijungęs",
   "hems.home.useStatus": "Naudojimo būsena",
   "hems.home.workModeText": 'Dabartinis darbo režimas:',
   "hems.home.toggleDataSourceText": 'Rodytini duomenys pakeisti į:',
   "hems.ev.charge.status": "Įkrovimo būsena",
   "hems.ev.charge.time": "Įkrovimo trukmė",
   "hems.ev.charge.count": "Realaus laiko įkrovimo kiekis",
   "hems.ev.charge.status.empty":"Laisvas",
   "hems.ev.charge.status.ing":"Įkraunama su prijungtu kabeliu",
   "hems.ev.charge.status.null":"Prijungtas kabelis, neįkraunama",
   "hems.ev.charge.status.error":"Gedimas",
   "hems.hour":"valanda",
   "hems.minue":"minutė",
   "hems.ev.chagre.number": "Įkroviklio numeris",

   // Vartotojo vadovas
   "hems.userGuide.selfUse": "Savitarpio naudojimas",
   "hems.userGuide.selfUseTips": "Pirmiausia naudojama saulės energija, trūkumai papildomi iš tinklo",
   "hems.userGuide.economyMode": "Ekonomijos režimas",
   "hems.userGuide.economyModeTips": "Energijos vartojimas optimizuojamas pagal elektros kainas",
   "hems.userGuide.emergencyMode": "Avarinis režimas",
   "hems.userGuide.emergencyModeTips": "Pirmiausia užtikrinama kritinės apkrovos maitinimas",

   // Grafiko puslapis
   "hems.history.energyStatistics": "Energijos statistika",
   "hems.history.revenueStatistics": "Pajamų statistika",
   "hems.history.greenStatistics": "Žalioji poveikio mažinimas",
   "hems.history.revenueTitle": "Bendros pajamos iš elektros pardavimo",
   "hems.history.savingsTitle": "Bendras sutaupymas",
   "hems.history.carbonTitle": "Bendras sumažintas anglies dioksido išmetimas",
   "hems.history.day": "Diena",
   "hems.history.month": "Mėnuo",
   "hems.history.year": "Metai",
   "hems.history.beforeDay": "Ankstesnė diena",
   "hems.history.afterDay": "Kita diena",
   "hems.history.beforeMonth": "Ankstesnis mėnuo",
   "hems.history.afterMonth": "Kitas mėnuo",
   "hems.history.beforeYear": "Ankstesni metai",
   "hems.history.afterYear": "Kiti metai",
   "hems.history.totalUse": 'Bendras naudojimas',
   "hems.history.fullScreen": 'Visas ekranas',
   "hems.history.timeSelect": "Datos pasirinkimas",
   "sync.tips1": "Sinchronizavimo komanda sėkmingai išsiųsta!",
   "sync.tips2":"Duomenų sinchronizavimas vyksta, dėl didelio duomenų kiekio gali užtrukti iki pusvalandžio, grįžkite vėliau~",
   "sync.tips3": "Įrenginio duomenų sinchronizavimas gali vėluoti. Jei duomenys atrodo netikslūs, spustelėkite:",
   "sync.tips4": "Sinchronizuoti duomenis",

   "charge.info": "Įkroviklio informacija",
    "news.loading": 'Kraunama...',
    "news.noMore": 'Daugiau nėra',
    "hems.pv.power": 'Saulės energijos tiekimas',

  // UEH specifika
  "ueh.sellPower": "Parduotos elektros kiekis",
  
  "menu.home": "Pagrindinis",
  "menu.history": "Istorija",
  "menu.device": "Įrenginiai",
  "menu.settings": "Nustatymai",
  "menu.messageCenter": "Pranešimai",
  "menu.help": "Pagalba ir palaikymas",
  "menu.mine": "Mano paskyra",


  "mine.userSetting": "Vartotojo nustatymai",
  "mine.terminalSetting": "Prietaiso pagrindiniai nustatymai",
  "mine.uploadCloud": "Duomenų atsarginė kopija debesyje",
  "mine.changeVersion": "Tikrinti atnaujinimus",
  "mine.language": "Keisti kalbą",
  "mine.about": "Apie",
  "mine.feedback": "Atsiliepimai",
  "mine.logout": "Atsijungti",
  "mine.logoutAccount": "Ištrinti paskyrą",

  "mine.logoutAccountTips": "Ištrinti paskyrą vardu []",
  "mine.logoutAccountTips1": "Ištrinti [] susietą paskyrą",
  "mine.logoutAccountCare": "Svarbu panaikinant paskyrą:",
  "mine.logoutAccountCare1": "1. Paskyra yra saugioje būsenoje",
  "mine.logoutAccountCare1-1": "Paskyra šiuo metu naudojama normaliai, nėra pavojaus, kad ji būtų pavogta, pažeista, išjungta ir pan.",
  "mine.logoutAccountCare2": "2. Paskyros leidimai/ryšiai atjungti",
  "mine.logoutAccountCare2-1": "Paskyra nutraukė leidimus su trečiųjų šalių paslaugomis.",
  "mine.logoutAccountCare3": "3. Paskyros negalima atkurti po ištrynimo, visi duomenys ištrinami",
  "mine.logoutAccountCare3-1": "Ištrynus paskyrą, visi duomenys ir susieti telefono numeriai/el. pašto adresai pašalinami negrąžinamai.",
  "mine.confirmLogout": "Patvirtinti ištrynimą",
  "mine.logoutSuccess": "Paskyra sėkmingai ištrinta!",

  "mine.feedbackIssues": "Pranešti apie problemas",
  "mine.feedQuantity": "Kiekis",
  "mine.feedAmount": "Maksimaliai 9 nuotraukos, maksimaliai 1MB/nuotrauka",

  "mine.notice.fail": "Nepavyko gauti pranešimų nustatymų!",
  "mine.notice.saveSuccess": "Pranešimų nustatymai sėkmingai išsaugoti!",
  "mine.notice.saveFail": "Išsaugoti nepavyko!",
  "mine.notice.title": "Pranešimų nustatymai",
  "mine.notice.batteryLow": "Pranešimas apie žemą baterijos lygį",
  "mine.notice.chargingFinish": "Pranešimas apie įkrovimo užbaigimą",
  "mine.notice.error": "Klaidų pranešimas",
  "mine.notice.update": "Atnaujinimo pranešimas",
  "mine.notice.monthly": "Mėnesinės statistikos pranešimas",
  "mine.notice.receiveType": "Gavimo būdas",

  "mine.language.welcome": "Sveiki atvykę į SusprSafe",
  "mine.language.desc1": "Pasirinkite kalbos versiją pagal savo regioną",
  "mine.language.desc2": "Galite tai pakeisti bet kuriuo metu programėlės nustatymuose",

  "mine.userInfo.avatar":"Profilio nuotrauka",
  "mine.userInfo.nickname":"Slapyvardis",
  "mine.userInfo.password":"Slaptažodis",
  "mine.userInfo.changePassword":"Keisti slaptažodį",
  "mine.userInfo.setPassword":"Nustatyti slaptažodį",
  "mine.userInfo.phoneNumber":"Telefono numeris",
  "mine.userInfo.bindPhone":"Susieti telefono numerį",
  "mine.userInfo.bindEmail":"Susieti el. paštą",
  "mine.loginExpired":"Prisijungimas baigėsi, prisijunkite iš naujo",
  "mine.userInfo.title":"Vartotojo informacija",
  "mine.userInfo.bind":"Susieti",
  "mine.userInfo.modify": "Keisti",
  "mine.userInfo.modifyNickname":"Keisti slapyvardį",
  "mine.userInfo.userNickname":"Vartotojo slapyvardis",
  "mine.userInfo.selectPic":"Pasirinkite nuotrauką įkėlimui",
  "mine.userInfo.saveSuccess":"Išsaugota sėkmingai",
  "mine.userInfo.uploadFail":"Įkelti nepavyko",
  "mine.userInfo.avatarSaveSuccess":"Profilio nuotrauka išsaugota",
  "mine.userInfo.nameTips1":"Slapyvardis negali būti tuščias",
  "mine.userInfo.nameTips2":"Įveskite slapyvardį",

  "common.pleaseSelect": "Pasirinkite",
  "question.commonQuestions": "Dažniausiai užduodami klausimai",
  "account.toggleLanguage": 'Keisti kalbą',
  "account.localConnection": "Vietinis ryšys",
  "account.selectLanguage": 'Pasirinkite kalbą',
  "account.sendEmailToast": "Patvirtinimo kodas išsiųstas el. paštu xxx, patikrinkite savo pašto dėžutę",
  "account.emailError": "Neteisingas el. pašto adresas",
  "account.sendEmailFail": "Siuntimas nepavyko, bandykite dar kartą",

  "common.submitting": "Pateikiama, prašome palaukti...",

  "device.page.noData": "Duomenų nėra, šį puslapį galima peržiūrėti tik programėlėje"
 
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};